import CHAT_IMAGE from "../images/CHAT_IMAGE.png";

interface Assets {
  [key: string]: string; // Or more specific if you have defined types, e.g., rothchild | tauga
}

export const ASSETS: Assets = {
  AI_CHAT_IMAGE: CHAT_IMAGE,
};
